import { useState, useEffect } from "react";
import placeholderImg from "./silhouette_A4.png";
import ModelModule from '../../../components/ModelModule';
import Select from '../../../audi-ui-components/Select';
import Button from '../../../audi-ui-components/Button';
import Modal from '../../../audi-ui-components/Modal';
import Spinner from '../../../audi-ui-components/Spinner';
import cn from "classnames";
import API from '../../../functions/api';
import _find from 'lodash/find';
import _get from 'lodash/get';

const PriceCalculatorComponent = ({
  className,
  locState,
  heading = "Starting price calculator",
  subheading,
  disclaimersLabel = "Disclaimers",
  onChange = ()=>{},
  onClickDisclaimers = ()=>{},
  theme
}) => {
  
  const [showDisclaimers, setShowDisclaimers] = useState(false);

  const [loading, setLoading] = useState(false);
  const [hasError, setHasError] = useState(false);

  const [prices, setPrices] = useState({});

  const [selectedModelId, setSelectedModelId] = useState("");
  const [selectedModel, setSelectedModel] = useState(null);
  const [selectedVariantId, setSelectedVariantId] = useState("");
  const [selectedVariant, setSelectedVariant] = useState(null);
  const [selectedEngineId, setSelectedEngineId] = useState("");
  const [my, setMy] = useState("");
  const [engineOpts, setEngineOpts] = useState([]);

  const auiTheme = theme === "dark" ? "light" : null;

  const getPrices = () => {
    // console.log("getPrices");
    if (selectedVariantId && selectedEngineId && locState) {
      var selectedEngine = _find(engineOpts, function (o) { return o.value?.toString() === selectedEngineId.toString()});
      // console.log("getPrices", selectedEngine, selectedEngineId, engineOpts);
      setLoading(true);
      setHasError(false);
      API.get(
        `/1/legacy/GetPrice?variantId=${selectedVariantId}&state=${locState}&engineId=${selectedEngineId}`
      ).then((response) => {
        // console.log("getPrices", response);
        if (response.data?.success) {
          var newPrices = response.data?.data || {};
          setPrices(newPrices);
          onChange(newPrices, selectedVariant, selectedEngine);
        } else {
          // console.error(response);
          setHasError(true);
          setPrices({});
          onChange();
        }
        setLoading(false);
      }).catch((error) => {
        // console.error(error);
        setLoading(false);
        setHasError(true);
        onChange();
      });
    }
  }

  const onChangeEngine = (v, _opts) => {
    // console.log("onChangeEngine", v);
    let opts = _opts || engineOpts;
    let eng = _find(opts, {value: v});
    let my = "";
    if (eng && eng.modelCode) {
      let i = eng.modelCode.indexOf("/");
      my = "MY" + eng.modelCode.substr(i + 1, 2);
    }
    setSelectedEngineId(v);
    setMy(my);
    // this.getPrices(undefined, v, undefined);
  }

  const onChangeVariant = (field, v, opt) => {
    // console.log("onChangeVariant", field, v);
    // model
    if (field === 'modelId') {
      setSelectedModelId(v);
      if (!v || v === null) {
        setSelectedModel(null);
      } else {
        setSelectedModel(opt);
      }
    }
    // variant
    if (field === 'variantId') {
      if (!v || v === null) {
        setSelectedVariantId(v);
        setSelectedVariant(null);
        setSelectedEngineId("");
        setEngineOpts([]);
        setPrices({});
        onChange();
        return;
      }
      setLoading(true);
      setSelectedVariantId(v);
      setSelectedVariant(opt);
      // console.log("onChangeVariant", selectedVariant);
      API.post(`${process.env.RAZZLE_GQLAPI}`, {
        query: /* GraphQL */`query ($skip: Int, $take: Int, $sort: EngineDtoSortInput!, $filter: EngineDtoFilterInput) {
          engineList(skip: $skip, take: $take, order: [ $sort ], where: $filter) {
            items {
              value: engineId
              label: name
              modelCode
            }
            totalCount
          }
        }`,
        variables: {
          skip: 0,
          take: 50,
          sort: {displayOrder: "ASC"},
          filter: {status: {eq: true}, variantId: {eq: v}}
        }
      }).then((response) => {
        var opts = response.data?.data?.engineList?.items ? response.data.data.engineList.items : [];
        setEngineOpts(opts);
        if (opts.length > 0) {
          onChangeEngine(opts[0].value, opts);
        } else {
          setLoading(false);
        }
      }).catch((error) => {
          console.error(error);
          setLoading(false);
      });
    }
  }

  useEffect(() => {
    if (locState && selectedEngineId) {
      getPrices();
    }
  }, [locState, selectedEngineId]);
  
  return (
    <div className={cn("price-calc-component position-relative", className)}>
      {loading && <div className="spinner-wrapper"><Spinner isContinuous /></div>}
      <h2 className="aui-headline-3 mb-3">{heading}</h2>
      {subheading}
      <div className="img-wrapper mb-3">
        {prices?.ImagePath && selectedVariant && <img src={prices.ImagePath} alt={selectedVariant.name} />}
        {!prices?.ImagePath && <img src={placeholderImg} className="placeholder-img" alt="" />}
      </div>
      <div className="mb-5">
        <ModelModule
            labelVariant="Body type"
            colClass="col-12 col-small-6"
            values={{modelId: selectedModelId, variantId: selectedVariantId}}
            setFieldValue={onChangeVariant}
            form="startingPrice"
            includeOptionObjOnChange
            theme={theme}
        />
        <div className="form-field">
          <Select name="engine"
              label="Engine"
              value={selectedEngineId}
              options={engineOpts}
              onChange={onChangeEngine}
              theme={auiTheme}
          />
        </div>
        {hasError && !loading && selectedEngineId && <p className="aui-small aui-color-text-red mb-3">Sorry, there was an error getting the pricing for that vehicle. Please try refreshing the page.</p>}
      </div>

      
      
      <table className={cn("price-table aui-small mb-4", {"active": prices?.MLP && !loading})}>
          <tbody>
              <tr>
                  <td>Manufacturer{`'`}s Recommended Retail Price (Inc. GST)<sup>I</sup></td>
                  <td>{prices?.MLP}{!prices && "$--"}</td>
              </tr>
              <tr>
                  <td>Recommended Dealer Delivery Fee (Inc. GST)<sup>II</sup></td>
                  <td>{prices?.DealerDeliveryFee}{!prices && "$--"}</td>
              </tr>
              <tr>
                  <td>Federal Govt Luxury Car Tax (LCT)</td>
                  <td>{prices?.LCT}{!prices && "$--"}</td>
              </tr>
              <tr>
                  <td>{locState} State Govt Total Registration<sup>III</sup></td>
                  <td>{prices?.TotalRegistration}{!prices && "$--"}</td>
              </tr>
              <tr>
                  <td>{locState} State Govt Stamp Duty</td>
                  <td>{prices?.StampDuty}{!prices && "$--"}</td>
              </tr>
              <tr>
                  <td><b>Vehicle Drive Away Price*</b></td>
                  <td><b>{prices?.VehicleDriveAwayPrice}{!prices && "$--"}</b></td>
              </tr>
          </tbody>
      </table>
      
      <Button variant="text" onClick={()=>{ setShowDisclaimers(true); onClickDisclaimers(); }} theme={auiTheme}>{disclaimersLabel}</Button>
      
      <Modal isActive={showDisclaimers} variant="layer" closeButton close={()=>{ setShowDisclaimers(false); }}>
        <div className="pe-5">
          <p className="mb-3">
            Prices effective from 20-12-2025<br />
            Pricing does not take into account any current promotion.<br />
            Contact your preferred Audi Dealer for any applicable promotional details.<br />
            Statutory charges current as at 20-12-2025.
          </p>
          <p className="mb-3"><b><sup>I</sup>Manufacturer&apos;s Recommended Retail Price (incl. GST)</b> - Manufacturer&apos;s recommended retail price, includes GST but excludes dealer delivery fees, statutory charges and optional extras.</p>
          <p className="mb-3"><b><sup>II</sup>Recommended Dealer Delivery Fee (incl. GST)</b> - Dealer delivery fee recommended by Audi Australia. Dealers may charge a different dealer delivery fee, which may be higher or lower.</p>
          <p className="mb-3"><b><sup>III</sup>NSW State Govt Total Registration</b> - Registration fees are in accordance with the applicable state or territory legislation, fitted with a premium licence plate (where applicable) and based on private ownership.</p>
          <p className="mb-3"><b><sup>*</sup>Vehicle Drive Away Price</b> - Manufacturer&apos;s recommended driveaway price (MRDP) displayed for new Audi Vehicles (with no optional extras). MRDP is an estimated price which includes the manufacture&apos;s recommended retail price, 12 months private registration, 12 months compulsory third party insurance (CTP), an estimated dealer delivery charge, stamp duty and other applicable statutory charges that may apply such as Luxury Car Tax (LCT) for private use vehicles above a certain threshold. The MRDP displayed is based on information available at the time the price was calculated and published and does not constitute a binding quote or an offer of sale. The actual driveaway price will be agreed with the selling Audi Dealer. Actual prices and stock availability will vary between locations and dealers, and on-road costs will vary according to individual circumstances. Please contact your local Audi Dealer to confirm your individual driveaway price and vehicle lead-time. While stocks last.</p>
          <p className=""><b><sup>*</sup>Price Calculator</b> - Finance available to approved applicants of Audi Financial Services (AFS) ABN 20 097 071 460, Australian Credit Licence Number 389344. AFS is a trading name of Volkswagen Financial Services Australia Pty Limited ABN 20 097 071 460. Standard credit assessment and lending criteria apply. The information provided by the price calculator is indicative only. No result from the use of the calculator should be considered a loan application or an offer of a loan. All information provided by the price calculator is of a general nature, based on the information you have provided and does not take into account your specific personal needs and financial circumstances. To check if this product is right for you, please see our website for our Target Market Determination document and get independent legal, financial or taxation advice. Nothing on this website constitutes or should be construed to constitute legal, taxation, or financial advice. Except for any statutory consumer guarantees which cannot be excluded, AFS gives no warranty in relation to your use of the AFS price calculator or the accuracy of the information generated by the AFS price calculator. The information provided by the price calculator is published on behalf of AFS.</p>
        </div>
      </Modal>
    </div>
  );
}

export default PriceCalculatorComponent;
